import { render, staticRenderFns } from "./PreviousVersions.vue?vue&type=template&id=67f57250&scoped=true&"
import script from "./PreviousVersions.vue?vue&type=script&lang=js&"
export * from "./PreviousVersions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f57250",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f57250')) {
      api.createRecord('67f57250', component.options)
    } else {
      api.reload('67f57250', component.options)
    }
    module.hot.accept("./PreviousVersions.vue?vue&type=template&id=67f57250&scoped=true&", function () {
      api.rerender('67f57250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/modals/PreviousVersions.vue"
export default component.exports